import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotEntertainmentComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotEntertainment',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F5990D",
    fillRule: "evenodd",
    d: "M3 10.157h17.945c.58 0 1.055.464 1.055 1.031v9.78c0 .568-.475 1.032-1.055 1.032H4.065c-.58 0-1.054-.464-1.054-1.032v-9.77L3 10.158Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F5990D",
    fillRule: "evenodd",
    d: "M20.22 8.07 4.08 11.335c-.34.068-.996.317-1.065-.064-.035-.216-.102-.534-.147-.75l-.84-4.164a1.02 1.02 0 0 1 .793-1.21l16.14-3.266a1.03 1.03 0 0 1 1.212.804l.84 4.163a1.02 1.02 0 0 1-.794 1.222Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FCC406",
    fillRule: "evenodd",
    d: "m14.329 9.27 3.948-.804-1.248-6.188-3.937.793 1.237 6.2Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FCC406",
    d: "m9.088 3.877-3.923.794 1.251 6.188 3.924-.793-1.252-6.189Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FCC406",
    fillRule: "evenodd",
    d: "M15.155 15.243a.978.978 0 0 1 0 1.692l-2.166 1.248-2.167 1.248a.978.978 0 0 1-1.465-.846v-5.013a.978.978 0 0 1 1.465-.846l2.167 1.248 2.166 1.269Z"
  }));
};
SpotEntertainmentComponent.displayName = 'SpotEntertainment';
export var SpotEntertainment = withProvisionalOverrideFromContext(SpotEntertainmentComponent);
//# sourceMappingURL=index.js.map